export default {
  setUsers: (state, users) => {
    state.users = users;
  },

  setUsersLoaded: (state, val = true) => {
    state.usersLoaded = val;
  },

  resetUsersCache(state) {
    state.users = [];
    state.usersLoaded = false;
  },

  setUsersTimezones: (state, usersTimezones) => {
    state.usersTimezones = usersTimezones;
  },

  setUser: (state, user) => {
    let users = state.users.slice(0);
    let idx = users.findIndex((i) => i.id == user.id);
    if (idx === -1) {
      users.push(user);
    } else {
      for (let key in user) {
        users[idx][key] = user[key];
      }
    }

    state.users = users;
  },

  setUserLoading: (state, loading) => {
    state.userLoading = loading;
  },

  setPermissions: (state, permissions) => {
    state.allPermissions = permissions;
  },

  setCurrentUser: (state, user) => {
    state.currentUser = Array.isArray(user) ? null : user;
  },

  updateCurrentUser: (state, { param, value }) => {
    state.currentUser[param] = value;
  },

  setCurrentUserLoaded: (state, loaded) => {
    state.currentUserLoaded = loaded;
  },

  setUsersView: (state, view) => {
    state.usersView = view;
  },

  setUsersSearch: (state, search) => {
    state.usersSearch = search;
  },

  updateAchievement: (state, achievements) => {
    state.achievements = [...new Set([...state.achievements, ...achievements])];
  },

  setAchievementsLoaded: (state) => {
    state.achievementsLoaded = true;
  },
};
